import { RootState } from '@store/reducers';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Modal, Spinner } from "react-bootstrap";
import '../beneficiary.css';
import VerificationAbha from './Abha';
import VerificationPhoneNumber from './PhoneNumber';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { postDataJSON } from '@services/CommonApiService';
import endpoints from '@config/endpoints';
import { useDispatch } from 'react-redux';
import { setAadhar, setBeneficiaryMobileNumber, setTsnID, beneficiaryAlreadyInRCH,beneficiariesInRCH,setBeneficiaryData, updateChild } from '@store/actions/beneficiaryAction';
import { toast } from 'react-toastify';
import { errorLogger } from '@utils/applicationLogUtils';
import { benef_error_const } from "@constants/beneficiaryConstant";
import { startOtpCooldown, isOtpRateLimitedError, useOtpCooldown } from '@hooks/useOtpCooldown';
import { otpCooldownMessage } from '@constants/appConstants';


interface showModalProps {
    showModal: boolean;
    handleClose: (authType: string, abhaNumber?:any, mobileNumber?:any, abhaAddress?:any, beneficiaryDetails?:any) => void;
    linkedBenefDetails:any;
    setLinkedBenefDetails:Dispatch<SetStateAction<string>>;
};
const BeneficiaryExistsModal = ({ showModal, handleClose, linkedBenefDetails, setLinkedBenefDetails }: showModalProps) => {    
    const [showSpinner, setSHowSpinner] = useState<boolean>(false);
    const beneficiary = useSelector((state: RootState) => state.beneficiary);
    const benefData = useSelector((state: RootState) => state.beneficiary.beneficiaryData);
    const mobNumberWithMsg = useSelector((state: RootState) => state.beneficiary.beneficiaryMobileNumber);
    const aadharNumber = useSelector((state: RootState) => state.beneficiary.aadhar);
    const mobNumber = mobNumberWithMsg?.split(' ')[mobNumberWithMsg.split(' ').length-1];
    const [linkedBenefName, setLinkedBenefName] = useState<string>('');
    const [linkedBenefPhone, setLinkedBenefPhone] = useState<string>('');
    const existsCooldownIdentifier =
        beneficiary.beneficiaryRedgeOption === 'Aadhaar' ? aadharNumber : mobNumber;
    const { secondsLeft, isCoolingDown } = useOtpCooldown(existsCooldownIdentifier);
   

    useEffect(()=>{
        if(linkedBenefDetails)
        {
            setLinkedBenefName(linkedBenefDetails?.[0]?.benf_name);
            setLinkedBenefPhone(linkedBenefDetails?.[0]?.mob);
        }
    },[linkedBenefDetails]);
    
    const dispatch = useDispatch()

    
    const createErrorMessage = (abdmMessage: string, rchMessage?: string) => (
        <div>
            <p><strong>ABDM:</strong> {abdmMessage}</p>
            {rchMessage && <p><strong>JANANI:</strong> {rchMessage}</p>}
        </div>
    );

    const handleError = (message: string, rchMessage?: string) => {
        const errorMessage = createErrorMessage(message, rchMessage);
        toast.error(errorMessage, {
            position: "top-center",
        });
        setSHowSpinner(false);
        handleClose('back');
    };
    

    const sendOTPforPhoneFlow = async (mobile: string) => {
        try {
            const data = {
                "mobile": mobile
            }
            const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
            const response = await postDataJSON<any>(`${endpoints.verifyAbhaByMobileNumberSendOtp}`, { data: encodedPayload });
            const decodedData = JSON.parse(decodeWithKeyAndShift(response.data));
            if (decodedData?.txnId){
                setSHowSpinner(false);
                dispatch(setBeneficiaryMobileNumber(`${decodedData.message} ${mobile}`));
                dispatch(setTsnID(decodedData.txnId))
                dispatch(beneficiaryAlreadyInRCH(true))
                handleClose('yes');
            }
            else if (decodedData?.message?.includes('does not match')) {
                handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.provideCorrectPhone);
            }
            else if (decodedData?.message?.includes('30 seconds')) {
                handleError(decodedData.message);
            } else if (decodedData?.message?.includes('multiple OTPs')) {
                handleError(decodedData.message, benef_error_const?.multipleOTP);
            } else if (decodedData?.message?.includes('Aadhaar Gateway is unavailable')) {
                handleError(decodedData?.message);
            }
            else if (decodedData?.message?.includes('Missing Credentials')) {
                handleError(`${decodedData?.code} - ${decodedData.description}`);
            }
            else if(decodedData?.message?.includes('Too many request attempted')){
                handleError(`${decodedData?.message}`);
            }
            else if (decodedData?.message?.includes('Runtime Error')) {
                handleError(`${decodedData?.code} - ${decodedData.message}`, benef_error_const?.urlNotFound);
            }
            else if(decodedData?.loginId.includes('Invalid LoginId')){
                handleError(`${decodedData?.loginId}`, benef_error_const?.provideCorrectPhone);
            }
            else{
                handleError(`${decodedData?.message ?? benef_error_const.genericAbdmMessage}`);
            }
        } catch (error:any) {
            if (isOtpRateLimitedError(error)) {
                startOtpCooldown(mobile);
                handleError(otpCooldownMessage);
                return;
            }
            const decodedData = JSON.parse(decodeWithKeyAndShift(error));
            const res = decodedData;
            let catchErrorMessage = '';
            if(res?.message && res?.code){
                catchErrorMessage =`${res?.code} - ${res?.message}`
            }else if(res?.message && !res?.code){
                catchErrorMessage =`${res?.message}`
            }else if(res?.loginId){
                catchErrorMessage =`${res?.loginId}`
            }else if(res?.Aadhaar){
                catchErrorMessage =`${res?.Aadhaar}`
            }else{
                catchErrorMessage = benef_error_const.genericAbdmMessage
            } 
            handleError(catchErrorMessage);
            errorLogger(res, "Phone OTP Generation-verifyAbhaByMobileNumberSendOtp");
        }
    }



    const sendOTPforAdhaarOTPFlow = async (aadharNumber: string, mobileEntered: string) => {
        try {
            const data = {
                aadhaar: aadharNumber,
            };
            const encodedPayload = encodeWithKeyAndShift(JSON.stringify(data));
            const aadharResponse = await postDataJSON<any>(`${endpoints.createAbhaViaAadhaar}`, { data: encodedPayload },);
            const decodedData = JSON.parse(decodeWithKeyAndShift(aadharResponse.data));
            const res = decodedData;
            dispatch(setBeneficiaryMobileNumber(`${res.message} ${mobileEntered}`));
            dispatch(setTsnID(res.txnId));
            dispatch(setAadhar(aadharNumber));
            if (res?.txnId) {
                setSHowSpinner(false);
                dispatch(beneficiaryAlreadyInRCH(true));
                handleClose('yes');
            }
            else if (res?.message?.includes('Runtime Error')) {
                handleError(`${res?.code} - ${res.message}`, benef_error_const?.urlNotFound);
            } else if (res?.message?.includes('30 seconds')) {
                handleError(res.message);
            } else if (res?.message?.includes('multiple OTPs')) {
                handleError(res.message, benef_error_const?.multipleOTP);
            } else if (res?.message?.includes('Missing Credentials')) {
                handleError(`${res?.code} - ${res?.description}`);
            } else if(res?.message?.includes('Too many request attempted')){
                handleError(`${res?.message}`);
            } else if (res?.message?.includes('Aadhaar Gateway is unavailable')) {
                handleError(res?.message);
            } else if (res?.loginId?.includes('Invalid LoginId')) {
                handleError(res?.loginId, benef_error_const?.provideCorrectAadhaar);
            } else {
                handleError(res?.message ?? benef_error_const.genericAbdmMessage);
            }
        } catch (error: any) {
            if (isOtpRateLimitedError(error)) {
                startOtpCooldown(aadharNumber);
                handleError(otpCooldownMessage);
                return;
            }
            const decodedData = JSON.parse(decodeWithKeyAndShift(error));
            const res = decodedData;
            let catchErrorMessage = '';
            if(res?.message && res?.code){
                catchErrorMessage =`${res?.code} - ${res?.message}`
            }else if(res?.message && !res?.code){
                catchErrorMessage =`${res?.message}`
            }else if(res?.loginId){
                catchErrorMessage =`${res?.loginId}`
            }else if(res?.Aadhaar){
                catchErrorMessage =`${res?.Aadhaar}`
            }else{
                catchErrorMessage = benef_error_const.genericAbdmMessage
            } 
            handleError(catchErrorMessage);
            errorLogger(res, "Aadhar OTP Generation-createAbhaViaAadhaar");
        }
    }

    const sendOTPforAdhaarDemoFlow = async (data:any) =>{
                handleClose('yes', data?.abhaId, data?.mob, data?.address, data);
    }

    const handleYesForABHA =async () =>{
        setSHowSpinner(false);
        handleClose('yes', benefData?.[0]?.abhaId, benefData?.[0]?.mob, benefData?.[0]?.address, benefData?.[0]);
        dispatch(beneficiaryAlreadyInRCH(true))
    }

    

    const handleAuthClick = (authType: string) => {
        handleClose(authType);
    };

    function handleBackClick(): void {
        setSHowSpinner(false);
        handleClose('back');
        dispatch(beneficiaryAlreadyInRCH(false))
    }


    function handleYesClick(): void {
        setSHowSpinner(true);
        if(beneficiary.beneficiaryRedgeOption === 'Phone_Number')
        {
            sendOTPforPhoneFlow(mobNumber)

        }
        else if(beneficiary.beneficiaryRedgeOption === 'Aadhaar' && beneficiary.beneficiaryAuthType === 'OTP')
        {
            sendOTPforAdhaarOTPFlow(aadharNumber, mobNumber)
        }
        else if(beneficiary.beneficiaryRedgeOption === 'Aadhaar' && beneficiary.beneficiaryAuthType === 'Demographics')
        {
            sendOTPforAdhaarDemoFlow(benefData[0]);
        }
        else if(beneficiary.beneficiaryRedgeOption === 'ABHA')
        {
            handleYesForABHA();
        }
    }

    function handleDiscardClick(): void {
        handleAuthClick('')
        dispatch(beneficiaryAlreadyInRCH(false));
        dispatch(updateChild('isChildRegistration', false));
    }
    

    return (
        <>
            <div className="modal_verification_beneficiaries">
                <Modal
                    show={showModal}
                    onHide={() => handleAuthClick('')}
                    dialogClassName={'benef-exists-modal'}
                    centered={true}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "400px" }}>
                            <div className="d-flex align-items-center beneficiary_back_button" onClick={handleBackClick}>
                                <i className="bi bi-arrow-left" style={{ cursor: "pointer" }} ></i>
                                <span className="ms-1">Back</span>
                            </div>
                            <div className="d-flex align-items-center beneficiary_discard_button" onClick={handleDiscardClick}>
                                <span className="me-0">Discard</span>
                                <i className="bi bi-x" ></i>
                            </div>

                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <>
                            <p style={{fontSize:"18px", textAlign:"center"}}>{`Entered mobile number ${linkedBenefPhone} is already registered with another beneficiary ${linkedBenefName}. Do you want to continue now to link mobile number ${linkedBenefPhone} with the same beneficiary?`}</p>
                            {isCoolingDown && (
                                <p style={{ color: '#b42318', fontSize: '12px', textAlign: 'center', margin: '8px 0 0' }}>
                                    You can request for new OTP after {secondsLeft} seconds
                                </p>
                            )}
                            <div style={{display:'flex', gap:'16px', alignItems:"center", justifyContent:"center", margin:"16px 0"}}>
                                {
                                showSpinner ? <Spinner /> :
                                <>
                                    <button onClick={handleYesClick} disabled={isCoolingDown} style={{padding:"6px 16px", color:"white", border:'none', borderRadius:"5px", background:"#af2d94", opacity: isCoolingDown ? 0.6 : 1, cursor: isCoolingDown ? 'not-allowed' : 'pointer'}}>Yes</button>
                                    <button onClick={handleBackClick} style={{padding:"6px 16px", color:"white", border:'none', borderRadius:"5px", background:"#af2d94"}}>No</button>
                                </>
                                }
                            </div>
                        </>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    );
};

export default BeneficiaryExistsModal;